<template>
  <v-container fluid>
    <v-row>
      <v-col cols="4">
        <v-card dark color="blue-grey">
          <v-card-title>Copia de seguridad</v-card-title>
          <v-card-subtitle>
            <label for="">
              Crea una copia de respaldo y restauración para tu base de datos
              (por default en: Documentos)
            </label>
          </v-card-subtitle>
          <v-card-text class="mt-4 mb-4">
            <div class="mb-2">
              <h4 class="white--text">La ubicación de tus respaldos</h4>
              <p v-text="hint"></p>
              <span>
                Respaldos en este directorio:
                <v-chip small class="ml-2">{{ fileCount }}</v-chip>
              </span>
            </div>
            <v-btn @click="selectFolder" outlined>
              <v-icon class="mr-2">mdi-folder</v-icon>
              Selecciona otra ubicación
            </v-btn>
            <p class="text--caption">*para tus respaldos</p>
          </v-card-text>
          <v-card-actions>
            <!-- <v-spacer></v-spacer> -->
            <v-btn :key="buttonKey" @click.once="makeBackup">
              <v-icon class="mr-2">mdi-database-plus</v-icon>
              Crear respaldo
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card dark color="cyan">
          <v-card-title>Restablece desde un respaldo</v-card-title>
          <v-card-subtitle>
            <label for="">
              Usa un respaldo para restablecer tu base de datos.
            </label>
          </v-card-subtitle>
          <v-card-text class="mt-4 mb-4">
            <v-btn @click="selectBackupFile" outlined>
              <v-icon class="mr-2">mdi-folder</v-icon>
              Selecciona el respaldo
            </v-btn>
            <p class="text--caption">
              *el archivo que creaste como copia de seguridad
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import uiMixin from "../../../mixins/mixin-ui.js";
// const {
//   createBackUp,
//   restoreFromBackup,
//   getBackUpFolderPath,
//   setBackUpFolderPathBackground,
//   getBackUpFileCount,
// } = api.services.backUpService;
export default {
  name: "BackupConfig",
  data() {
    return {
      path: "",
      backUpFileCount: 0,
    };
  },
  mixins: [uiMixin],
  computed: {
    ...mapGetters(["user"]),
    hint() {
      return this.backupFolderPath
        ? this.backupFolderPath
        : "Selecciona una ubicación de respaldo";
    },
    fileCount: {
      get: function () {
        return this.backUpFileCount;
      },
      set: function (count) {
        this.backUpFileCount = count;
      },
    },
    backupFolderPath: {
      get: function () {
        return this.path;
      },
      set: function (path) {
        this.path = path;
      },
    },
  },
  methods: {
    ...mapActions([
      "showLoadingIndicator",
      "setSuccessMessage",
      "showSuccessModal",
    ]),
    createBackUp(){},
    restoreFromBackup(){},
    getBackUpFolderPath(){},
    setBackUpFolderPathBackground(){},
    getBackUpFileCount(){},
    fetchBackUpFileCount() {
      this.getBackUpFileCount().then((fileCount) => {
        this.fileCount = fileCount;
      });
    },
    selectBackupFile() {
      this.restoreFromBackup().then((backupResult) => {
        console.log("[selectBackupFile|backupResult] ", backupResult);
      });
    },
    selectFolder() {
      const self = this;
      this.setBackUpFolderPathBackground(this.user.id).then((result) => {
        if (result) {
          self.fetchFolderPath();
          self.fetchBackUpFileCount();
        }
      });
    },
    makeBackup() {
      const self = this;
      self.showLoadingIndicator(true);
      const dbParentFolderPath = this.getBackUpFolderPath();
      this.createBackUp(dbParentFolderPath.value)
        .then(() => {
          self.fetchFolderPath();
          self.fetchBackUpFileCount();
          self.setSuccessMessage("Respaldo guardado exitosamente!");
          setTimeout(() => {
            self.showLoadingIndicator(false);
            self.resetButtonClickState();
            self.showSuccessModal(true);
          }, 1000);
        })
        .catch((error) => console.error("error", error));
    },
    fetchFolderPath() {
      const backupFolder = this.getBackUpFolderPath();
      this.backupFolderPath = backupFolder?.value;
    },
  },
  beforeMount() {
    this.fetchFolderPath();
    this.fetchBackUpFileCount();
  },
};
</script>
<style>
</style>